// extracted by mini-css-extract-plugin
export default {"site":"day_site__NkpWr","homeLink":"day_homeLink__DyVF3","ball":"day_ball__CF9U8"};